export default "__VITE_ASSET__Bj8QQyru__"